var map = {
	"./fomede_LIBER_Data-Set-15.png": "3973",
	"./fomede_LIBER_Data-Set-6.png": "4352",
	"./fomede_LIBER_açaí.png": "0ae7",
	"./fomede_LIBER_burger.png": "079e",
	"./fomede_LIBER_comida-fit.png": "006d",
	"./fomede_LIBER_cupcake.png": "35af",
	"./fomede_LIBER_dadinho.png": "de2a",
	"./fomede_LIBER_esfiha.png": "472d",
	"./fomede_LIBER_feijoada.png": "74cc",
	"./fomede_LIBER_frango-frito.png": "71f5",
	"./fomede_LIBER_hambúrguer.png": "51aa",
	"./fomede_LIBER_japa.png": "f153",
	"./fomede_LIBER_lanche.png": "edb7",
	"./fomede_LIBER_macarrão.png": "4557",
	"./fomede_LIBER_marmita.png": "5057",
	"./fomede_LIBER_panqueca.png": "9ce6",
	"./fomede_LIBER_pastel.png": "70d1",
	"./fomede_LIBER_pão.png": "bdb7",
	"./fomede_LIBER_risoto.png": "cef5",
	"./fomede_LIBER_salada.png": "c785",
	"./fomede_LIBER_salgadinho.png": "871f",
	"./fomede_LIBER_sanduba.png": "561f",
	"./fomede_LIBER_sonho.png": "883a",
	"./fomede_LIBER_sorvete.png": "745c",
	"./fomede_LIBER_yakisoba.png": "6ac2",
	"./março-on-fire-restaurantes-feed.png": "a6c4",
	"./março-on-fire-restaurantes-story.png": "23e9",
	"./modelo_feed_com_logo.png": "8cf5",
	"./modelo_stories_com_logo.png": "0502",
	"./vemproapp_generica_restaurante_feed.png": "47c0",
	"./vemproapp_generica_restaurante_story.png": "1c15",
	"./vestamosnoaiq_desconto_black-feed.png": "d961",
	"./vestamosnoaiq_desconto_black-story.png": "d90e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b2e7";